/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Edit_CancelInputs */

const es_user_profile_edit_cancel = /** @type {(inputs: User_Profile_Edit_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const en_user_profile_edit_cancel = /** @type {(inputs: User_Profile_Edit_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {User_Profile_Edit_CancelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_edit_cancel = /** @type {((inputs?: User_Profile_Edit_CancelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Edit_CancelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_edit_cancel(inputs)
	return en_user_profile_edit_cancel(inputs)
});
export { user_profile_edit_cancel as "user.profile.edit.cancel" }